import React from "react";

const NotFound = () => {
  return <div>Bad route</div>;
};

export default NotFound;
